import { call, put, takeLatest } from 'redux-saga/effects';

import { buttonUpdateError, buttonUpdateRequest, buttonUpdateStore } from './buttonActions.js';
import { updateButtonApiCall } from './buttonAPI.js';

function* updateButtonSaga({ payload }) {
  try {
    yield call(updateButtonApiCall, payload);
    yield put(buttonUpdateStore());
  } catch (error) {
    yield put(buttonUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* emailsButtonWatcher() {
  yield takeLatest(buttonUpdateRequest.type, updateButtonSaga);
}
